import React from 'react';
import { AccountSidbarUser } from '../../../../types/user/eleve.def';
import { useSelector } from 'react-redux';
import { getUserSidebar } from '../../../../store/selectors/user/user.selectors';
import useGoToPage from '../../../../hooks/useGoToPage';
import pages from '../../../../routes/pages';
import useIsMobile from '../../../../helpers/responsive/useIsMobile';
import SidebarView from './Sidebar.view';

export interface SidebarProps {
  menu?: React.ReactElement;
  publicLayout?: boolean;
}

const Sidebar = React.memo(({ menu, publicLayout = false }: SidebarProps) => {
  const user: AccountSidbarUser = useSelector(getUserSidebar);
  const goToDashboard = useGoToPage(pages.HOME_PAGE.path);
  const isMobile = useIsMobile();

  return (
    <SidebarView
      menu={menu}
      publicLayout={publicLayout}
      user={user}
      goToDashboard={goToDashboard}
      isMobile={isMobile}
    />
  );
});

Sidebar.displayName = 'Sidebar';

export default Sidebar;
